<template>
  <div id="top-tabs" style="width: 100%" v-if="tabs.length > 1">
    <div style="width: 100%; height: 100%;"></div>
    <el-tabs :key="reload" v-model="activeTab" type="border-card" closable @tab-remove="handleTabClose">
      <el-tab-pane
        v-for="item in tabs"
        :key="item.id"
        :label="item.title"
        :name="item.id+''"
        :id="item.id"
        :link="item.link"
      ></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  let $ = window.$
  import Sortable from 'sortablejs'

  export default {
    name: 'main-top-tabs',
    data () {
      return {
        reload: true
      }
    },
    computed: {
      tabs: {
        get () {
          return this.$store.state.user_session.navigation.tabs
        },
        set (active) {
          this.$store.state.user_session.navigation.tabs = active
        }
      },
      active: {
        get () {
          return this.$store.state.user_session.navigation.active
        },
        set (active) {
          this.$store.state.user_session.navigation.active = active
        }
      },
      activeTab: {
        get () {
          return this.active + ''
        },
        set (id) {
          let tab = this.tabs.find(tab => tab.id === parseInt(id))

          this.active = tab.id
          this.$router.push(tab.link)
        }
      },
      pageTitle () {
        return this.$store.state.app.ui.title
      }
    },
    watch: {
      tabs (value) {
        if (value.length > 1) {
          $('#wrapper').addClass('with-tabs')
          this.handleTabSort()
        } else {
          $('#wrapper').removeClass('with-tabs')
        }
      },
      pageTitle (value) {
        this.tabs[this.active - 1].title = value
        this.tabs[this.active - 1].link = window.location.hash.replace('#/', '/')
      }
    },
    methods: {
      handleTabClose (targetId) {
        targetId = parseInt(targetId)
        let self = this

        // Moving all the tabs ids offsets for filling the gap
        this.tabs = this.tabs.filter(tab => tab.id !== targetId).map((item, offset) => {
          item.id = offset + 1
          return item
        })

        // Get the active tab with the previous actual index (it is usually the next tab)
        let activeTab = this.tabs.find(tab => tab.id === self.active)

        // If we found a tab with the same index, just refresh the url
        if (typeof activeTab !== 'undefined') {
          this.$router.push(activeTab.link)
        } else {
          // If we don't find any tab with this index, we closed the last tab, so take the
          // last one available and set it clicked (will refresh automatically)
          activeTab = this.tabs[this.tabs.length - 1]
          this.activeTab = activeTab.id
        }
      },
      handleTabSort () {
        let self = this

        let tabs = document.querySelector('#top-tabs .el-tabs__nav')
        if (tabs !== null) {
          Sortable.create(tabs, {
            scroll: false,
            onEnd ({newIndex, oldIndex}) {
              let tabs = JSON.parse(JSON.stringify(self.tabs))
              tabs.splice(newIndex, 0, tabs.splice(oldIndex, 1)[0])
              let newActive = null
              for (let i = 0; i < tabs.length; i++) {
                if (tabs[i].id === self.active) {
                  newActive = i + 1
                }
                tabs[i].id = i + 1
              }
              self.tabs = tabs
              self.active = newActive

              self.reload = !self.reload
              self.$nextTick(() => {
                self.handleTabSort()
              })
            }
          })
        }
      }
    },
    mounted () {
      document.addEventListener('auxclick', (e) => {
        if (e.which === 2) {
          let aNode = null
          for (let i = 0; i < e.path.length; i++) {
            if (e.path[i].nodeName === 'A') {
              aNode = e.path[i]
            }
          }

          if (aNode !== null) {
            e.preventDefault()

            let link = aNode.hash.replace('#/', '/')
            let existing = this.tabs.filter(item => item.link === link)

            if(existing.length === 0) {
              this.tabs.push({
                title: aNode.innerText,
                id: this.tabs.length + 1,
                link
              })
            } else {
              this.active = existing[0].id
              this.$router.push(existing[0].link)
            }
          } else if (e.target.className === 'el-tabs__item is-closable') {
            this.handleTabClose($(e.target).index() + 1)
          }
        }
      }, false)

      if (this.tabs.length > 1) {
        $('#wrapper').addClass('with-tabs')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// MainTopTabs.vue?89f16ad0